<template>
  <div id="app" :style="{ height: viewportHeight }">
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Footer from './common/Footer'
import { connectWs, onMessage } from '@/common/ws'
import { stripCurrency } from '@/common/recharge'

export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0,
      paidOrders: {},
      wsOff: null
    };
  },
  methods: {
    handleWsMessage(msg) {
      if (!msg) return
      if (msg.type === 'error') {
        try { localStorage.removeItem('token') } catch (e) {}
        if (this.$route.path !== '/Login') this.$router.replace('/Login')
        return
      }
      if (msg.type === 'recharge' && msg.event === 'paid') {
        this.handleRechargePaid(msg.data || {})
        return
      }
      if (msg.type === 'notice' && msg.event === 'new') {
        if (this.$route.path !== '/Notice') {
          this.$store.commit('setNoticeUnread', true)
        }
      }
    },
    handleRechargePaid(data) {
      const orderNo = data && data.order_no
      if (!orderNo || this.paidOrders[orderNo]) return
      this.paidOrders[orderNo] = true

      // 以服务端入账为准：重新拉用户信息，不在前端加余额
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          this.$store.commit('setUserInfoValue', res.data)
        }
      })

      // 充值页自己会弹成功窗，避免重复 toast
      if (this.$route.path !== '/Recharge') {
        const money = data.money ? stripCurrency(data.money) : ''
        this.$toast.success(
          money
            ? `${this.$t('recharge.pay_success')} +${money}`
            : this.$t('recharge.pay_success')
        )
      }
    },
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token') && this.$route.path != "/Login"){
          this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    resetHeight() {
      const viewportHeight = window.innerHeight
      this.viewportHeight = `${viewportHeight}px`
      console.log(viewportHeight)
    },

  },
  created(){
    // 全局只注册一次 WS 订阅；有 token 时建立唯一长连接
    this.wsOff = onMessage(this.handleWsMessage)
    connectWs()
    this.getBaseInfo();
    this.resetHeight()


    
    const i = 'orientationchange' in window ? 'orientationchange' : 'resize'
    const setViewHeight = () => {
      const windowVH = window.innerHeight / 100
      document.documentElement.style.setProperty('--vh', windowVH + 'px')
    }
    document.addEventListener('DOMContentLoaded', setViewHeight)
    window.addEventListener(i, setViewHeight)
  },
  beforeDestroy() {
    if (this.wsOff) {
      this.wsOff()
      this.wsOff = null
    }
  }
}
</script>

<style>
html, body{
  overflow: hidden;
  background: #f7f1f8;
  scrollbar-width: thin;
  scrollbar-color: #f3a3c4 transparent;
}
#app {
  width: 31.25rem;
  margin: 0 auto;
  /* height: var(--vh) * 100; */
  /* background: #f0f0f0; */
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0 0 .13333rem rgba(0, 0, 0, .2);
  scrollbar-width: thin;
  scrollbar-color: #f3a3c4 transparent;
}
::-webkit-scrollbar {
  width: 0.35rem;
  height: 0.35rem;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  border-radius: 1rem;
  background: linear-gradient(180deg, #f7a1c0 0%, #c3a3f2 100%);
}
::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #f59ab8 0%, #b79cec 100%);
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background: transparent;
}
body .van-toast {
  box-sizing: border-box;
  width: auto !important;
  min-width: 8rem;
  max-width: 80%;
  height: auto !important;
  padding: 0.75rem 1.1rem;
  font-size: 0.9rem;
  line-height: 1.45;
  word-break: break-word;
  white-space: normal;
  text-align: center;
  border-radius: 0.5rem;
  background: linear-gradient(30deg, rgba(245, 96, 205, .8), rgba(79, 43, 138, .78));
}
body .van-toast--loading {
  width: 7rem !important;
  min-width: 7rem;
  max-width: 7rem;
  height: 7rem !important;
  padding: 1rem;
}
body .van-toast .van-toast__text {
  margin: 0;
  word-break: break-word;
  white-space: normal;
}
body .van-toast .van-toast__icon {
  font-size: 2.13rem;
}
::v-deep .van-toast .van-loading__spinner{
  width: 2.50rem !important;
  height: 2.50rem !important;
}
*, :after, :before {
  box-sizing: border-box;
}

#content{
  overflow-y: auto;
  padding-top: 2.875rem;
}


.van-nav-bar {
  background: linear-gradient(120deg, #f3a3c4 0%, #c3a6f0 55%, #ffb894 100%);
  height: 2.875rem;
  position: fixed !important;
  z-index: 1000 !important;
  width: 31.25rem;
  max-width: 100%;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  color: #fff;
}
.van-nav-bar .van-icon {
  font-size: 1.15rem !important;
}
.van-nav-bar .van-nav-bar__title {
  color: #fff;
  max-width: 68% !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block !important;
}

.van-nav-bar__content {
  height: 2.875rem !important;
  line-height: 2.875rem !important;
}

.van-nav-bar__title span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


@media (max-width: 31.25rem) {
    #app {
        width: 100%;
    }
    .van-nav-bar {
        width: 100%;
        left: 0;
        transform: none;
    }
}

/* PC 端：底部弹层跟随 #app 宽度并居中，避免选择器横跨整个屏幕 */
@media (min-width: 31.25rem) {
    .van-popup--bottom,
    .van-popup--top {
        left: calc(50% - 15.625rem) !important;
        right: auto !important;
        width: 31.25rem !important;
        max-width: 100% !important;
    }
    .van-popup--center {
        max-width: 31.25rem !important;
    }
}

.van-toast{
  background: linear-gradient(30deg, rgba(245, 96, 205, .8), rgba(79, 43, 138, .78));
}

.van-pull-refresh__head  span{
  font-size: 1.00rem !important;
}
.van-pull-refresh__head  div{
  font-size: 1.00rem !important;
}
.van-loading {
  height: 3.13rem !important;
  line-height: 3.13rem !important;
}
.van-pull-refresh__head {
  height: 3.13rem !important;
  line-height: 3.13rem !important;
}
</style>
